import React from "react"

export const Sparkline = ({ values = [], className = "" }) => {
  const max = Math.max(...values, 1)
  return (
    <div className={`flex items-end gap-[2px] h-6 ${className}`} title={values.map(value => `${value} h`).join(" · ")}>
      {values.map((value, index) => (
        <span
          key       = {index}
          className = {`w-[5px] rounded-sm ${index === values.length - 1 ? "bg-slate-700" : "bg-slate-300"}`}
          style     = {{ height: `${Math.max(value > 0 ? 12 : 4, (value / max) * 100)}%` }}
        />
      ))}
    </div>
  )
}

// Bar = share of the sold hours spent, tick = progress: a bar past the tick spends faster than it moves.
export const ConsumptionBar = ({ consumed, progress, progressKnown }) => {
  const width = Math.min(100, consumed || 0)
  const ahead = progressKnown && (consumed || 0) - (progress || 0) > 15
  const over  = (consumed || 0) > 100
  const tone  = over ? "bg-rose-500" : ahead ? "bg-amber-400" : "bg-emerald-500"
  return (
    <div className="relative h-1.5 w-full rounded-full bg-slate-100">
      <div className={`absolute inset-y-0 left-0 rounded-full ${tone}`} style={{ width: `${width}%` }} />
      {progressKnown && (
        <div className="absolute -top-[3px] -bottom-[3px] w-[2px] rounded bg-slate-800" style={{ left: `calc(${Math.min(100, progress)}% - 1px)` }} />
      )}
    </div>
  )
}
